import { fetchEmployeesByIdArray } from "../services/employee";

export const getEmployeeNames = async(apiData, employeeIds, key) => {
    const rows = Array.isArray(apiData) ? apiData : [];
    const uniqueEmployeeIds = [...new Set(employeeIds || [])];
    // nothing to look up — return rows with a null employee
    if (uniqueEmployeeIds.length === 0) {
      return rows.map(data => ({ ...data, employee: null }));
    }
    const res = await fetchEmployeesByIdArray(uniqueEmployeeIds);
    const employees = Array.isArray(res?.data) ? res.data : [];
    return rows.map(data => {
         const employee = employees.find(emp => emp?._id === data[key]) || null;
         return {
           ...data,
           employee: employee ? { fname: employee.fname, lname: employee.lname } : null
         };
    });
  }

  export const getEmployeeDetails = async(apiData, employeeIds, key) => {
    const rows = Array.isArray(apiData) ? apiData : [];
    const uniqueEmployeeIds = [...new Set(employeeIds || [])];
    if (uniqueEmployeeIds.length === 0) {
      return rows.map(data => ({ ...data, employee: null }));
    }
    const res = await fetchEmployeesByIdArray(uniqueEmployeeIds);
    const employees = Array.isArray(res?.data) ? res.data : [];
    return rows.map(data => {
         const employee = employees.find(emp => emp?._id === data[key]) || null;
         return {
           ...data,
           employee: employee ? employee : null
         };
    });
  }
